import { Reducer } from "redux";

import { OrderAcceptorResponse } from "../models/Api/Master";
import { OrderAcceptorDispatchTypes } from "../models/DispatchTypes/Master";
import { OrderAcceptorActionDispatchTypes } from "../constants/Master";
import { setLocalStorageData } from "../utils";

const initialState: OrderAcceptorResponse = {
  loading: false,
  response: [],
};

const OrderAcceptor: Reducer<
  OrderAcceptorResponse,
  OrderAcceptorDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case OrderAcceptorActionDispatchTypes.GET_ORDER_ACCEPTOR_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case OrderAcceptorActionDispatchTypes.GET_ORDER_ACCEPTOR_SUCCESS: {
      setLocalStorageData(
        OrderAcceptorActionDispatchTypes.GET_ORDER_ACCEPTOR_SUCCESS,
        action.response
      );
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case OrderAcceptorActionDispatchTypes.GET_ORDER_ACCEPTOR_ERROR: {
      return initialState;
    }
  }
  return state;
};

export default OrderAcceptor;
